import React, { useEffect } from 'react';
import { Box, Container } from '@mui/material';
import { makeStyles } from '@mui/styles';
import theme from '../theme';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { isMembershipSelected } from '../helpers/Actions';
import SelectBuilding from '../components/SelectBuilding';
import DashThreeBody from '../components/DashThree/DashThreeBody';
import Cookies from 'universal-cookie';
import { useNavigate } from 'react-router-dom';

const useStyles = makeStyles(() => ({
  containerContent: {
    width: 'calc(100% - 48px) !important',
    height: 'calc(100vh - 112px)',
    backgroundColor: theme.background,
    padding: '24px',
  },
}));

const DashThree = ({ selMembership }) => {
  const classes = useStyles();
  const cookies = new Cookies();
  const navigate = useNavigate();

  const rotateDashboards = () => {
    const displayRotating = cookies.get('dashsToRotate');
    const indexThisDash = displayRotating.findIndex((item, index) => {
      return item.index === 2;
    });
    console.log('indexThisDash THREE: ', indexThisDash);

    displayRotating.splice(indexThisDash, 1);
    navigate(displayRotating[0].link, { replace: true });
  };

  const checkIfDashThreeRotate = () => {
    const displayRotating = cookies.get('dashsToRotate')
      ? cookies.get('dashsToRotate')
      : [];
    const flag = displayRotating.filter((d) => d.index === 2).length > 0;
    console.log('flag ONE: ', flag);

    return flag;
  };

  /* useEffect(() => {
    if (selMembership.buildingName) {
      setTitle('Detalle de herramientas en préstamo');
    } else {
      setTitle('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selMembership]); */

  useEffect(() => {
    let mounted = true;
    if (
      cookies.get('isDisplayChange') === 'true' &&
      checkIfDashThreeRotate() &&
      parseInt(cookies.get('tvNum') ? cookies.get('tvNum') : 0) === 2
    ) {
      setInterval(() => {
        if (mounted) {
          rotateDashboards();
        }
      }, 330 * 1000);
    }

    return () => (mounted = false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selMembership]);

  return (
    <>
      <Helmet>
        <title>Alliot TV</title>
      </Helmet>
      <Box className={classes.containerContent}>
        <Container maxWidth={false}>
          {isMembershipSelected() ? <DashThreeBody /> : <SelectBuilding />}
        </Container>
      </Box>
    </>
  );
};

const mapStateToProps = (state) => ({
  selMembership: state.membershipSelectedRed.membership,
});

export default connect(mapStateToProps, null)(DashThree);
